/**
 * Handle simple errors
 */
export default {
  methods: {
    /**
     * @vuese
     * Error handling function
     */
    errorHandlingAction(error) {
      this.$logger.debug(error)
      const message = typeof error === 'object' ? error.responseJSON.message : error
      this.serverErrors.push({
        code: 500,
        message
      })
    }
  }
}
